import { render, staticRenderFns } from "./AccountForgot.vue?vue&type=template&id=e91e0258"
import script from "./AccountForgot.vue?vue&type=script&lang=js"
export * from "./AccountForgot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports